import * as React from 'react';

import styled from '../../theme';
import { AboutRenderer, IRenderProps } from '../../models/About';
import { withRouter, RouteComponentProps } from 'react-router';

const Container = styled.div`
  position: relative;
  margin: 25px auto 0;

  @media (min-width: ${props => props.theme.aboutBreakpoint}px) {
    margin: 50px auto 0;
  }
`;

const Title = styled.h1`
  margin: 0;
  display: block;
  font-size: 16px;
  text-align: center;
  font-weight: normal;
  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }
`;
const Subtitle = styled.h2`
  margin: 0;
  display: block;
  font-size: 16px;
  text-align: center;
  font-weight: normal;
  margin-top: 5px;
  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }
`;

const BackButton = styled.div`
  position: absolute;
  left: 0;
  cursor: pointer;

  @media (max-width: ${props => props.theme.maxWidth}) {
    left: 10px;
  }

  &:hover {
    transform: scaleY(-1);
  }
`;

const Header = withRouter(
  class extends React.PureComponent<IRenderProps & RouteComponentProps<{}>> {
    render() {
      return (
        <Container>
          <BackButton onClick={this.props.history.goBack}>Back</BackButton>
          <Title>{this.props.data.fields.header}</Title>
          <Subtitle>{this.props.data.fields.subtitle}</Subtitle>
        </Container>
      );
    }
  }
);

export default function Wrapper() {
  return <AboutRenderer render={Header} />;
}



// WEBPACK FOOTER //
// ./src/scenes/About/Header.tsx